<template>
    <div>
        <el-header class="navbg">
            <div class="contBox">
                <hq-nav></hq-nav>
            </div>
        </el-header>
        <el-main class="mainBox" style="padding-top: 0;">
            <div class="contBox" id="contBox">
                <p class="indexBt">模组系列</p>
                <el-row>
                    <div class="navBox">
                        <ul class="navMenu">
                            <li
                                v-for="(d,index) in data.listData"
                                :key="index"
                                :class="{ clickLi:cur == d.cur }"
                                @click="liSwitch(d.cur)">
                                    <a href="javascript:void (0)"> {{ d.name }} </a>
                            </li>
                        </ul>
                    </div>
                    <el-col :span="24" class="textCont">
                        <div class="manet">
                            <h1>
                                <el-divider class="fg" direction="vertical"></el-divider>
                                {{ this.listData.name }}
                                <span  @click="vdlClick(listData.vdlJson,listData.spanText)">
                                    {{ this.listData.spanText }}
                                </span>
                            </h1>
                            <ul class="listBox">
                                <li v-for="(t,index) in this.listData.child" :key="index">
                                    <div class="imgSty"><img :src="require('../assets/images/'+ t.img)" :alt="t.name" :title="t.name"></div>
                                    <p :title="t.name">{{ t.name }}</p>
                                    <div class="hxHref" @click="listMore(t.name)">了解更多></div>
                                </li>
                            </ul>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-main>
        <el-footer class="footer">
            <hq-footer></hq-footer>
        </el-footer>

        <el-dialog :title="vdlTitle" :visible.sync="vdlDialog" width="80%" top="10vh" @open="diaOpen" class="diaStyle">
            <hq-vdl :fMes="data1"></hq-vdl>
        </el-dialog>
    </div>
</template>

<script>
    import Nav from "./Nav";
    import Footer from "./Footer";
    import VDLCont from "./VDLCont";

    export default {
        name: "ProductDetail",
        data () {
            return {
                data:require("../assets/JSON/ModuleList.json"),
                cur:"core",
                listData:[],
                vdlDialog:false,
                vdlTitle:"",
                data1:"VDL_Core.json",
                diaData:"",
                btText:"",

                jsonData: {},
                tableData: [],
                labelData:[]
            }
        },
        methods: {
            liSwitch(e){
                this.cur = e;
                this.$router.push({
                    path:`/moduleList/${e}`,
                });
            },
            listMore(e){
                this.$router.push({
                    path:`/moduleDetail/${e}`,
                });
            },
            vdlClick(n,t){
                this.$router.push({
                    path:`/vdlIndex/${n}/${t}`,
                });
            },
            diaOpen(){
                this.data1 = this.diaData;
            },

            setHeight(){
                let bodyH = document.body.clientHeight;
                let windowH = document.documentElement.clientHeight;
                let div = document.getElementById('contBox');
                div.style.minHeight = (div.clientHeight + (windowH - bodyH)) + "px";
            },
            tableClassName({rowIndex}){
                if (rowIndex % 2 == 0) {
                    return 'black-row';
                } else  {
                    return 'hui-row';
                }
            },
        },
        mounted() {
            let type = this.$route.params.type;
            switch (type) {
                case 'core':
                    this.cur = "core";
                    this.listData = this.data.listData[0];
                    break;
                case 'rf':
                    this.cur = "rf";
                    this.listData = this.data.listData[1];
                    break;
                case 'an':
                    this.cur = "an";
                    this.listData = this.data.listData[2];
                    break;
                case 'video':
                    this.cur = "video";
                    this.listData = this.data.listData[3];
                    break;
                case 'power':
                    this.cur = "power";
                    this.listData = this.data.listData[4];
                    break;
                default:
                    alert(123);
            }
            this.setHeight();
        },
        updated() {
            this.setHeight();
        },
        components : {
            "hq-nav":Nav,
            "hq-footer":Footer,
            "hq-vdl":VDLCont
        }
    }
</script>

<style scoped>
    .indexBt{
        background: #000000;
        color: #ffffff;
        text-align: left;
        margin: 0;
        box-sizing: border-box;
        padding-left: 2rem;
        font-size: 2rem;
        padding-top: 2rem;
        font-family: AlibabaPuHuiTi-Heavy;
    }
    .navbg{
        background: url("../assets/images/bg_2.jpg") no-repeat top center;
        background-size: 100% 100%;
    }
    .mainBox{
        background: #000000;
        padding: 5rem 0;
    }
    .navBox{
        box-sizing: border-box;padding-left: 2rem;
    }
    .navMenu{
        width: 15%;
        height: auto;
        border-left: 1px solid #414141;
        padding: 0;
        box-sizing: border-box;
        position: fixed;
    }
    .navMenu li{
        width: 100%;
        height: 2rem;
        line-height: 2rem;
        list-style: none;
        text-align: left;
        padding-left: 2rem;
        margin: 1rem 0 0 -0.15rem;
    }
    .navMenu li a{
        color: #414141;
        font-size: 1.5rem;
        text-decoration: none;
        font-family: AlibabaPuhuiTiR;
    }

    .navMenu li:hover a{
        font-family: AlibabaPuHuiTi-Bold;
        font-size: 1.75rem;
        color: #ffffff;
    }
    .navMenu li:hover{
        height: 3rem;
        line-height: 3rem;
    }
    .navBox li.clickLi{
        border-left: 4px solid #dd3010;
        background-size: 3rem 3rem;
        height: 3rem;
        line-height: 3rem;
        margin-bottom: 1rem;
    }
    .navBox li.clickLi a{
        font-family: AlibabaPuHuiTi-Heavy;
        font-size: 2.25rem;
        color: #ffffff;
    }

    .textCont{
        padding: 0 0 0 25%;
        box-sizing: border-box;
        text-align: left;
    }
    .manet{
        width: 100%;
        height: auto;
        overflow: hidden;
    }
    .manet h1{
        font-size: 1.5rem;
        font-family: AlibabaPuhuiTiR;
        color: #ffffff;
        font-weight: normal;
        border-bottom: 1px solid #545454;
    }
    .manet h1 span{
        font-family: AlibabaPuhuiTiR;
        color: #ffffff;
        font-weight: bold;
        font-size: 1rem;
        width: auto;
        height: auto;
        padding: 1rem 2rem;
        background: #d5382e;
        float: right;
        cursor: pointer;
    }

    .fg{
        width: 1.125rem;
        height: 1.625rem;
        color: #dd3010;
        margin-right: 1rem;
    }

    .listBox{
        width: 100%;
        height: auto;
        overflow: hidden;
        margin: 0;
        padding: 4.625rem 0 0;
    }
    .listBox li{
        list-style: none;
        width: 15rem;
        height: 16.125rem;
        float: left;
        margin:0 0rem 2rem;
    }
    .listBox li .imgSty{
        width: 12.0625rem;
        height: 8.625rem;
        margin: 0 auto;
        text-align: center;
    }
    .listBox li .imgSty img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .listBox li p{
        width: 100%;
        height: auto;
        font-size: 1.5rem;
        color: #ffffff;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }
    .listBox li .hxHref{
        width: 8.625rem;
        height: 2.5rem;
        background: #d5382e;
        font-size: 1rem;
        text-decoration: none;
        color: #ffffff;
        text-align: center;
        line-height: 2.5rem;
        margin: 0 auto;
        cursor: pointer;
    }
</style>